export default __webpack_public_path__ + "static/media/comment-delete.14f45f1a.svg";